/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const VendorApplicationForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();
  return (
    <form
      onSubmit={(e) => processForm(e, 'da31c1a4375f', null, captchaRef)}
      id="vendor-application-form"
    >

      <h3>Contact Name *</h3>
      <input
        name="Contact Name"
        id="contact-name"
        className="form-control"
        type="text"
        required
      />

      <h3>Company Name *</h3>
      <input
        name="Company Name"
        id="company-name"
        className="form-control"
        type="text"
        required
        data-use-for-filename
      />

      <h3>Company Address *</h3>
      <input
        name="Company Address"
        id="company-address"
        className="form-control"
        type="text"
        required
      />

      <h3>Cell Phone Number *</h3>
      <input
        name="Phone Number"
        id="phone-number"
        className="form-control"
        type="tel"
        required
      />

      <h3>Email address *</h3>
      <input
        name="Email"
        id="email"
        className="form-control"
        type="email"
        required
      />

      <h3>Company website</h3>
      <input
        name="Company Website"
        id="company-website"
        className="form-control"
        type="text"
      />

      <h3>Social media link *</h3>
      <input
        name="Social Media Link"
        id="social-media-link"
        className="form-control"
        type="text"
        required
      />

      <h3>Description of culinary concept to be served onsite *</h3>
      <input
        name="Service Description"
        id="service-description"
        className="form-control"
        type="textarea"
        rows="9"
        cols="33"
        required
      />

      <h3>Provide photos of a recent onsite setup *</h3>
      <label
        style={{ display: 'block', marginBottom: '5px' }}
        htmlFor="photo-submission"
      >
        Choose images to upload (PNG, JPG), maximum of 5MB total
      </label>
      <input
        name="Onsite Photos"
        id="photo-submission"
        className="form-control"
        type="file"
        multiple
        accept=".jpg,.jpeg,.png"
        required
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || ButtonText.SUBMIT}</button>
    </form>
  );
};

VendorApplicationForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
